import {SET_SMS_NUMBER} from 'src/pages/reportIssue/store/actions/creators';

export const smsNumber = (state = null, action) => {
  switch (action.type) {
    case SET_SMS_NUMBER:
      return action.value.smsNumber;
    default:
      return state;
  }
};
